export const CATEGORIES = {
  FEDERAL: 'FEDERAL',
  LOCAL: 'LOCAL',
  OEM: 'OEM',
};

export const CATEGORIES_SEQUENCE = [CATEGORIES.FEDERAL, CATEGORIES.LOCAL];
